import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
  { title: 'Social Media Marketing', desc: 'Building community and presence where your customers live.', icon: '📱', slug: 'social-media-marketing' },
  { title: 'Content Creation', desc: 'High-impact visuals and storytelling that demand attention.', icon: '✏️', slug: 'content-creation' },
  { title: 'SEO', desc: 'Climb the rankings and get found by the right audience.', icon: '🔍', slug: 'seo' },
  { title: 'Paid Ads', desc: 'Precision-targeted campaigns designed for maximum ROI.', icon: '🎯', slug: 'paid-ads' },
  { title: 'CRM & Automation', desc: 'Streamlining your workflow and nurturing leads on autopilot.', icon: '⚙️', slug: 'crm-automation' },
  { title: 'Graphic Design', desc: "Bespoke visual identities that define your brand's voice.", icon: '🎨', slug: 'graphic-design' },
  { title: 'Email Marketing', desc: 'Direct-to-inbox strategies that convert and retain.', icon: '📧', slug: 'email-marketing' },
  { title: 'Website Generation', desc: 'High-performance websites built for speed and conversion.', icon: '💻', slug: 'website-generation' },
];

export default function Services() {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    cardsRef.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services" id="services">
      <div className="section-header reveal" ref={el => cardsRef.current[0] = el}>
        <p className="label">What We Do</p>
        <h2>Full-Stack <br /><em>Digital Marketing</em></h2>
      </div>

      <div className="services__grid">
        {services.map((svc, i) => (
          <Link
            key={svc.title}
            className="service-card reveal"
            to={`/services/${svc.slug}`}
            ref={el => cardsRef.current[i + 1] = el}
            style={{ transitionDelay: `${i * 0.07}s` }}
          >
            <div className="service-card__icon" aria-hidden="true">{svc.icon}</div>
            <h3>{svc.title}</h3>
            <p>{svc.desc}</p>
            <span className="service-link">Learn More →</span>
          </Link>
        ))}
      </div>
    </section>
  );
}